/**
 * Finance → Control Presupuestario → Creators / Influencers (Finance 07/10/2026).
 *
 * Contrato entre el backend (lee BigQuery, `backend/src/lib/finance-creators-data.ts`)
 * y el front (arma KPIs, gráfico mensual, mix de oferta, segmento, región y clientes
 * con `shared/finance-creators.ts`). Importes en USD.
 *
 * Fuentes:
 *   spend    Capacity_Process.creators_influencers_2026_raw (planilla "Creators / Influencers
 *            2026" → BigQuery). Influencers = oferta 'IM'; Creators = el resto. Las filas sin
 *            oferta no entran en ninguno de los dos.
 *   revenue  Capacity_Process.Capacity_Final, SourceType 'Actual', PracticeName 'Content'
 *            (SUM(ValueForecast * IsPrimary)), para el ratio Costo / Revenue.
 */

import type { PnlSource } from './finance-pnl';

export type CreatorsKind = 'creators' | 'influencers';

/** Buckets de oferta de Creators. Lo que no es ADV / CBA / AMP / UGC va a 'Otros' (ORG, YT, ADV/CBA…). */
export const CREATORS_BUCKETS = ['ADV', 'CBA', 'AMP', 'UGC', 'Otros'] as const;
export type CreatorsBucket = (typeof CREATORS_BUCKETS)[number];

/** Spend agregado por (tipo, mes, bucket, segmento, región, empresa). */
export interface CreatorsSpendRow {
  kind: CreatorsKind;
  month: number;
  /** Solo en Creators; null en Influencers. */
  bucket: CreatorsBucket | null;
  segment: string;
  region: string;
  /** company_name tal como viene (trim). El agrupado por holding se hace en shared. */
  company: string;
  usd: number;
  /** Cantidad de registros (líneas de costo) de la planilla. */
  n: number;
}

/** Revenue de Content (Actual) por mes, segmento, región y cliente. */
export interface CreatorsRevenueRow {
  month: number;
  segment: string;
  region: string;
  client: string;
  usd: number;
}

export interface CreatorsDashboardData {
  year: number;
  /** Último mes con spend cargado (1-12). 0 = todavía no hay datos del año. */
  lastMonth: number;
  spend: CreatorsSpendRow[];
  revenue: CreatorsRevenueRow[];
  sources: PnlSource[];
  generatedAt: string;
}
